var map = {
	"./ecompim-logo.svg": "./src/assets/logos/ecompim-logo.svg",
	"./ecompim-mini-logo.svg": "./src/assets/logos/ecompim-mini-logo.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/logos sync recursive ^\\.\\/ecompim.*\\-logo\\.svg$";